<template>
  <div class="Account-Settigns">
    <div class="header-details">
      <h1>Account Settigns</h1>
    </div>
    <div class="Account-Settigns-main" v-if="windowSize > 991">
      <div class="left-content">
        <div class="navegation-card">
          <div class="header-navigation-card">
            <span>My Settings</span>
          </div>
          <div class="content-navigation-card">
            <ul>
              <li
                :class="select === 'Edit' ? 'select' : ''"
                @click="select = 'Edit'"
              >
                <div>
                  <font-awesome-icon class="icon" icon="pen" />Edit Profile
                </div>
                <font-awesome-icon
                  v-if="select === 'Edit' ? true : false"
                  icon="chevron-right"
                />
              </li>
              <li
                :class="select === 'Pass' ? 'select' : ''"
                @click="select = 'Pass'"
              >
                <div>
                  <font-awesome-icon class="icon" icon="shield-alt" />Password
                </div>
                <font-awesome-icon
                  v-if="select === 'Pass' ? true : false"
                  icon="chevron-right"
                />
              </li>
            </ul>
          </div>
        </div>
        <hr />
      </div>
      <div class="right-content">
        <EditProfileDescktopVue v-if="select === 'Edit'" />
        <PasswordDesktopVue v-if="select === 'Pass'" />
      </div>
    </div>
    <div class="Account-Settigns-main-movil">
      <v-expansion-panels v-model="panel" accordion multiple>
        <v-expansion-panel>
          <v-expansion-panel-header
            style="box-shadow: 0px 3px 30px 0px rgba(0, 0, 0, 0.161)"
            ><div class="custon-expansion">
              <font-awesome-icon class="icon" icon="pen" /> Edit Profile
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <FormEditProfileVue />
          </v-expansion-panel-content>
        </v-expansion-panel>
        <!-- ------------------------------ -->
        <v-expansion-panel>
          <v-expansion-panel-header
            style="box-shadow: 0px 3px 30px 0px rgba(0, 0, 0, 0.161)"
            ><div class="custon-expansion">
              <font-awesome-icon class="icon" icon="shield-alt" />Password
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <FormChangePasswordVue />
          </v-expansion-panel-content>
        </v-expansion-panel>
        <!-- ---------------------------------------- -->
        <v-expansion-panel class="aux-logout" @click="LogOutBtn">
          <v-expansion-panel-header
            ><div class="custon-expansion">
              <font-awesome-icon class="icon" icon="sign-out-alt" />Logout
            </div>
          </v-expansion-panel-header>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import EditProfileDescktopVue from "../components/AccountSettigns/EditProfile/EditProfileDescktop.vue";
import FormEditProfileVue from "../components/AccountSettigns/EditProfile/FormEditProfile.vue";
import FormChangePasswordVue from "../components/AccountSettigns/Password/FormChangePassword.vue";
import PasswordDesktopVue from "../components/AccountSettigns/Password/PasswordDesktop.vue";
export default {
  components: {
    FormChangePasswordVue,
    FormEditProfileVue,
    PasswordDesktopVue,
    EditProfileDescktopVue,
  },
  data: () => ({
    select: "Edit",
    panel: [0],
    windowSize: 0,
  }),
  methods: {
    ...mapActions("UserManager", ["LogOut"]),
    LogOutBtn() {
      this.LogOut();
      this.$router.push({ path: "/login" });
    },
    refactorWindow() {
      this.windowSize = window.innerWidth;
    },
  },
  mounted() {
    this.refactorWindow(true);
    window.addEventListener("resize", this.refactorWindow);
  },
  destroyed() {
    window.removeEventListener("resize", this.refactorWindow);
  },
};
</script>

<style>
.Account-Settigns {
  width: 100%;
}
.Account-Settigns .Account-Settigns-main {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.Account-Settigns .Account-Settigns-main-movil {
  display: none;
}
.left-content hr {
  background: var(--firts-color);
}
.right-content {
  width: 70%;
}

.navegation-card {
  border-radius: 10px;
  width: 290px;

  box-shadow: 0px 3px 30px 0px rgba(0, 0, 0, 0.161);
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  font-size: 22px;
  color: var(--dark-firts-color);
  margin: 15px 0;
}
.custon-expansion {
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  font-size: 1rem;
  color: var(--dark-firts-color);
}
.custon-expansion .icon {
  margin-right: 5px;
}
.navegation-card .header-navigation-card {
  border-bottom: 1px solid var(--firts-color);
  padding: 12px 0 0 10px;
}
.content-navigation-card {
  padding: 5px 0;
}
.content-navigation-card ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.content-navigation-card ul li {
  padding: 10px;
  cursor: pointer;
}
.content-navigation-card ul li.select {
  background: var(--third-color);
  font-weight: bold;
  border-left: 3px solid;
  border-image-slice: 1;
  border-width: 3px;
  border-image-source: linear-gradient(180deg, #7467f0 0%, #2896e9 100%);
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.content-navigation-card ul li .icon {
  font-size: 18px;
  margin-right: 8px;
}
/*=============================================
ESCRITORIO GRANDE (LG revisamos en 1366px en adelante)
=============================================*/
@media (min-width: 1200px) {
}
/*=============================================
ESCRITORIO MEDIANO O TABLET HORIZONTAL (MD revisamos en 1024px)
=============================================*/
@media (max-width: 1199px) and (min-width: 992px) {
}
/*=============================================
ESCRITORIO PEQUEÑO O TABLET VERTICAL (SM revisamos en 768px)
=============================================*/
@media (max-width: 991px) and (min-width: 768px) {
  .Account-Settigns .Account-Settigns-main {
    display: none;
  }
  .Account-Settigns .Account-Settigns-main-movil {
    display: block;
  }
  .aux-logout i {
    display: none !important;
  }
}
/*=============================================
MOVIL (XS revisamos en 320px)
=============================================*/
@media (max-width: 767px) {
  .Account-Settigns .Account-Settigns-main {
    display: none;
  }
  .Account-Settigns .Account-Settigns-main-movil {
    display: block;
  }
  .aux-logout i {
    display: none !important;
  }
}
</style>